module.exports = __webpack_public_path__ + "static/assembly-281240da4874f79b80c72d02695f42e6.gif";